import { cn } from '@/lib/utils';

// U+E000 \u2014 first codepoint of the Unicode Private Use Area. Inert in
// markdown rendering and (unlike U+200B / ZWSP) never appears in real
// content from NewsAPI / scripture / search-result bodies, so the
// remark cursorPlugin can safely match every occurrence and swap it
// for a <BlinkingCursor>. ZWSP collided with wire-copy artifacts that
// Gemma occasionally reproduced verbatim into assistant_messages,
// rendering as a permanent pulsing cursor mid-message.
export const CURSOR_PLACEHOLDER = '\uE000';

interface Props {
  whitespace?: boolean;
}

export default function BlinkingCursor({ whitespace }: Props) {
  return (
    <span className={cn('inline-block loading-cursor', whitespace && 'ml-2')} />
  );
}
